module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "CHAPTER 2 Understanding BEER",
      "src": "images/f0030-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "pull_quote"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" The first question is an existential one: Why is there beer? The answer will depend very much on your point of view.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("For the people who created it, beer was something a bit magical, a gift of the gods that provided nutrition and safe water, and engendered a relaxed feeling of intoxication that relieved the pains of a hard life and brought the community closer together—“meat and drink and cloth,” as it was described centuries ago in England. For some early people, the transformation of the soil, through barley, into beer was a metaphor for human domination of the earth. This is represented in the familiar image of a man we know today as St. George, on horseback slaying a dragon. But he is a late substitution; the rider was actually the god Sabazios, beloved of the barbarians in the Greek world, who associated him with beer and barley. Beer, we could say, is the serpent’s blood.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("For us today, beer is no less magical, but our needs are different. Three thousand years later, nature has been so thoroughly “conquered” that we are in fear of losing it altogether. The long march of progress has produced many benefits, but has created a land of sorry side effects as well. Modern industrial foods and beverages are mostly pale imitations of their natural counterparts, “food facsimiles,” as Brooklyn Brewery’s brewmaster Garrett Oliver calls them. Hand-brewed beer can serve as an antidote to this sad state of affairs. So while we long for the good old days, our need for community is as strong as ever. Beer answers the call as it always has, generously lubricating human interactions and making, where it is allowed to, a more civilized world in which to live.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("Besides being nutritious, flavorful, easily preserved, and more, beer relieves the cares of everyday life, fosters an esprit de corps (breaking down social barriers), and contributes to a joie de vivre. But it is preeminently a mind-altering substance, tapping into the mysteries of our existence (fermentation itself is magic) and the otherworldly functioning of our minds")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("PATRICK E. MCGOVERN,")]), _vm._v(" molecular anthropologist and author of "), _c('em', [_vm._v("Uncorking the Past")]), _vm._v(" and "), _c('em', [_vm._v("Ancient Wine")])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2lev1"
    }
  }), _vm._v("ANATOMY "), _c('span', {
    staticClass: "font"
  }, [_vm._v("of a")]), _vm._v(" BEER")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Before we start putting a beer together, it might be helpful to take one apart. Beer is a liquid solution of water and alcohol, infused with carbon dioxide, flavored and colored with small amounts of carbohydrates, proteins, minerals, melanoidins, and hundreds of aromatic compounds derived from malt, hops, and yeast. The specific quantities of all these substances—perhaps a thousand or more—give every beer its unique character and appeal.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "ch2lev2"
    }
  }), _vm._v("MEASURABLES")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The parameters that follow are the most commonly used numerical descriptors of beer. Many of these qualities can be accurately measured and are commonly used to analyze beer for quality control and other purposes. We will also use these numbers to describe beers and calculate recipes based on quantities of ingredients and other variables. Brewing organizations like the American Society of Brewing Chemists and the European Brewery Convention set the procedures and standards for analyzing beers, measurement units, and other specifics.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg32lev1"
    }
  }), _vm._v("GRAVITY")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is the density of wort, or unfermented beer, a measure of dissolved substances, mostly sugar that will be turned into alcohol, plus some miscellaneous unfermentable carbohydrates, proteins, and other material. It is a general indicator of the strength of the soon-to-be beer. Two systems are used to express this density: degrees Plato (°P) and original gravity (OG).")]), _vm._v(" "), _c('p', {
    staticClass: "first2_indent"
  }, [_vm._v("Plato expresses gravity as a percentage by weight. A 10°P wort contains 10 percent by weight of dissolved matter. Degrees Balling is an earlier measure corrected by Dr. Plato, but as Dr. Balling was Czech, you still see his name on the scale relative to Czech brewing. Winemakers use the term "), _c('em', [_vm._v("Brix")]), _vm._v(" for the same type of measurement.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_indent"
  }, [_vm._v("The second measure, original gravity, is the same as specific gravity, with the density expressed as a ratio relative to pure water; so a 1.040 wort is 1.040 times as dense as water. Sometimes the decimal point is omitted for convenience. It’s important to know that when doing calculations with OG, the “1” and decimal point at the beginning are left out. Otherwise the arithmetic doesn’t work. A very approximate rule of thumb is that the significant digit of an OG measurement often approximates alcohol content (1.050 = 5.0% alcohol/volume), although this is affected by many other factors.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("PLATO TO OG CONVERSION")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Gravity (°Plato) 0 2 4 6 8 10 12 14 16 18 20 22 24 26 1.000 1.010 1.020 1.030 1.040 1.050 1.060 1.070 1.080 1.090 1.100 1.110 Original Gravity",
      "src": "images/f0032-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("Plato (°P) and original gravity (OG) are two systems that measure the density of the wort, which is an early indicator of beer strength.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_indent"
  }, [_vm._v("Gravity is usually measured with a device called a hydrometer, normally a weighted glass tube with a scale inside that comes to rest at a certain level relative to the surface of the liquid being measured. The denser the liquid, the higher up the scale the hydrometer floats. A refractometer is sometimes used by more geeked-out homebrewers, as it is less messy and offers instant results. Because it measures original gravity by the refractive index of sugar, a refractometer is normally used to measure wort. In finished beer, alcohol distorts the reading, although correction spreadsheets are available.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg32lev2"
    }
  }), _vm._v("TERMINAL GRAVITY")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is expressed in the same units as original gravity but is a measurement of how much gravity is remaining at the end of fermentation, and from which the alcohol content of the finished beer can be calculated. This measurement is distorted by the presence of alcohol, which has a lower gravity than water "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#page_34"
    }
  }, [_vm._v("(see Attenuation, page 34")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("BEER COLOR")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "SRM COLOR NAME 2 3 4 6 9 12 15 18 20 24 30 40+ PALE STRAW STRAW PALE GOLD DEEP GOLD PALE AMBER MEDIUM AMBER DEEP AMBER AMBER-BROWN BROWN RUBY-BROWN DEEP BROWN BLACK",
      "src": "images/f0033-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("The range of beer colors and their corresponding Standard Reference Method (SRM) numbers. Note: Although the numbering system is standardized, there is no common agreement on color nomenclature.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg33lev1"
    }
  }), _vm._v("ALCOHOL")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is the percentage of ethanol (ethyl alcohol) present in the finished beer. The current international and U.S. federal standard is percent by weight, and that’s what we’ll be using in this book, but many U.S. state laws are specified in percent by weight, a measurement adopted after Prohibition to make alcohol content look relatively low (4 percent by weight equals 5 percent by volume).")]), _vm._v(" "), _c('p', {
    staticClass: "first2_indent"
  }, [_vm._v("Alcohol content can be measured only by distilling it out of the beer and weighing it. So, most small-scale brewers make a rough calculation based on original versus terminal gravities that is relatively accurate. In order to do this, a “potential alcohol” scale is used. A reading is taken before fermentation and then again at the end. The latter is subtracted from the former, and the result is pretty close to the actual alcohol content of the beer.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("POTENTIAL ALCOHOL AND ORIGINAL GRAVITY")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0033-02"
    }
  }), _c('img', {
    attrs: {
      "alt": "Alcohol Potential (% by volume) 0 1 2 3 4 5 6 7 8 9 10 11 12 13 1.000 1.010 1.020 1.030 1.040 1.050 1.060 1.070 1.080 1.090 1.100 Original Gravity",
      "src": "images/f0033-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("Use this scale to estimate the potential alcohol percentage of your finished beer.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg33lev2"
    }
  }), _vm._v("COLOR")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is a single value of lightness/darkness taken by putting a sample of beer into a spectrophotometer and reading the amount of absorption at a particular blue wavelength that is readily absorbed by beer. In the nineteenth century, Joseph Lovibond devised the first beer color scale using a series of colored glass disks. When the spectrophotometric method replaced the earlier method, it was found that the numbers matched up fairly closely with Lovibond’s, so sometimes you still see beer and malt color described in degrees Lovibond. U.S. and European standards differ by the thickness of the cuvette used to hold the sample beer—"), _c('span', {
    staticClass: "font11"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")])]), _vm._v(" inch in the U.S. Standard Reference Method (SRM), and 1 centimetre for the European Brewery Convention (EBC). Because of this, the same beer measured by the EBC method will have a number almost exactly twice as high as the SRM.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_indent"
  }, [_vm._v("In addition to light and dark, beer may vary in its hue from reddish to yellowish. Methods using multiple colors, called "), _c('em', [_vm._v("tristimulus")]), _vm._v(", can be used to measure beer in a way that matches more closely what the eye sees, but these are rarely used.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg33lev3"
    }
  }), _vm._v("BITTERNESS")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is measured by a chemical assay test that requires some fairly scary chemicals and an ultraviolet spectrophotometer. The worldwide standard of Bitterness Units (BU) corresponds to parts-per-million (mg/L) of isomerized alpha acid in the finished beer, which corresponds to the perceived bitterness of the beer. There is a European version (EBU) of the measurement that gives very slightly different numbers, but for the most part these systems can be thought of as the same. Most homebrewers and small-scale brewers use a calculated BU number, which may vary considerably from measured numbers, depending on a large number of factors, especially at the higher end. For super-hoppy beers like double IPAs and their ilk (greater than 80 BU or so), there is some doubt as to the reliability of the standard assays.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "pg34lev1"
    }
  }), _vm._v("ATTENUATION")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is a measure of how complete the fermentation is. It may be approximated by subtracting the final gravity from the original gravity, then dividing that number by the original gravity, and this gives a percentage. So if a 1.050 wort finishes at 1.010, then the 10 is subtracted from the 50, which gives 40, divided by 50, which equals 80 percent. This is called "), _c('em', [_vm._v("apparent attenuation")]), _vm._v(", and it is inaccurate to some degree because the lower density of alcohol distorts the reading, making the beer appear more attenuated than it actually is. With super-dry beers, apparent attenuations of more than 100 percent are possible. To measure real attenuation, the alcohol needs to be distilled out of the beer and measured, then factored into the calculation. For obvious reasons, most small brewers use apparent attenuation, and it serves quite nicely.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_indent"
  }, [_vm._v("The degree of attenuation is affected by a number of factors. Ingredients like sugar or honey are entirely fermentable, so they raise attenuation. Mashing technique also affects the fermentability of the wort, and is another tool the brewer can use to control the sweetness or dryness of the beer. Special techniques like fungus-derived enzymes are used to brew light, dry, and low-carb beers. Finally, yeast strain and fermentation conditions have an effect on attenuation that may be hard to predict.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("ATTENUATION IN BEER")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "°P 19 18 17 16 15 14 13 12 11 10 9 8 OG 1.080 1.075 1.070 1.065 1.060 1.055 1.050 1.045 1.040 1.035 1.030 APPARENT ATTENUATION 50% 55% 60% 65% 70% 75% 80% 85% 90% 95% 100% 3.0 3.5 4.0 4.5 5.0 5.5 6.0 6.5 7.0 7.5 8.0 8.5 9.0 9.5 % Alcohol/Volume",
      "src": "images/f0034-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("Apparent attenuation measures the completeness of fermentation. High apparent attenuation percentages indicate drier beers, while low apparent attenuation percentages indicate sweeter beers.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2lev3"
    }
  }), _vm._v("INTANGIBLES")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("We’re done with numbers for now, but there are other qualities of beer that are difficult or impossible to measure. These may include more concrete attributes but describe some sensory qualities that can be just as important as the measurable metrics. Body and texture are important in beer, as is head retention, all of which may be affected by its colloidal, or protein, structure. "), _c('em', [_vm._v("Balance")]), _vm._v(" is a term used to describe the way different flavors and aromas interact, especially hops and malt, but it’s not always just those two; other qualities that come into play include roastiness, acidity, fruitiness, and more. I prefer the term "), _c('em', [_vm._v("contrast")]), _vm._v(", which better sums up the dynamic interaction of elements that add interest as you taste. "), _c('em', [_vm._v("Drinkability")]), _vm._v(" is the old warhorse term industrial brewers used as a sad excuse for how little they have to offer consumers. It is nonetheless an important quality to all brewers because few can make much of a business out of beers that are only sippable. "), _c('em', [_vm._v("Complexity")]), _vm._v(" is an obvious term encompassing a lot, and is always desirable, even in the palest and most refreshing beer. There will be a much more extended discussion of these qualities in "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7"
    }
  }, [_vm._v("chapter 7")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Beyond all that is something I just call "), _c('em', [_vm._v("wonderfulness")]), _vm._v(". It’s a summation of everything tasty, magical, and profound in a beer. It’s a highly subjective and personal measure but one of the most important.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "ch2lev4"
    }
  }), _vm._v("TASTING "), _c('span', {
    staticClass: "font"
  }, [_vm._v("and")]), _vm._v(" EVALUATING BEER")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Beer is a product that affects all our senses in complex and profound ways. Despite the common notion that beer is a rather simple product, it is in fact a good deal more complex than wine, with twice as many known flavor compounds. Learning to be a good beer taster means understanding your own sensory system and how it interacts with the huge range of tastes, aromas, and textures that every beer presents. It’s a big challenge, but a worthy one, and as entertaining a pursuit as you can imagine.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "ch2lev5"
    }
  }), _vm._v("OUR SENSES")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Our eyes, lips, tongue, and nose are exquisitely attuned to appreciate beer’s pleasures. Everything we do in the brewing process is centered around providing an amazing sensory experience. It’s not just an important part of what beer is; beyond the alcohol, the sensory experience is the "), _c('em', [_vm._v("only")]), _vm._v(" thing that beer is.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("It makes sense that brewers learn to be expert tasters, ideally at a far higher and more informed level than the people who drink their beer. Without good sensory chops, it is impossible to evaluate how the various ingredients interact in a recipe, how the brewing process has affected the flavor, what contribution the yeast has made, and to recognize off-flavors and problems with style. It’s a serious discipline. Tasting is something that brewers have to work on with as much effort and determination as they do the actual brewing.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0035-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text_indentt"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("As a beer enthusiast and brewer, you already have some tasting experience, but becoming an expert taster involves attention and regular practice. It’s also too complex to do much more than a brief overview of the subject in this book. The good news is that all this hard work actually involves putting some beer in your mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The first step is to understand your sensory system. The senses of smell and taste have been shaped by hundreds of millions of years of evolution to inform us of good and bad things in the environment; they are the gatekeepers of what we consume. Smell and taste are processed in parts of our brains that are reactive and emotional rather than intellectual, which is one reason developing a good vocabulary of aromas is so difficult. It’s a long journey from our lizard brain way up to where language is processed.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Sight can be problematic in beer tasting. Our visual sense is so overpowering that it can dominate other senses, forcing them to confirm what our eyes see even when they’re getting it wrong. Wine judges presented with white wine colored red find all the expected fruit: cherries, bramble, mulberries, and so on. Beer people are not immune to this syndrome. If we are aware of it, we can use it like any perceptual reality harnessed to stoke the fires of art. Appearance matters. Proper presentation of beer is hugely important because it actually makes the beer taste better.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The tongue is a fairly straightforward chemical detector and the sense of taste is shared by other parts of the mouth, including the palate and inner surfaces of the cheeks and lips. Once in the mouth, chemicals in food and drink reach the taste buds, which are specialized cells living in the "), _c('em', [_vm._v("papillae")]), _vm._v(" (those bumps on your tongue) and elsewhere inside the mouth. These chemicals, which contain minerals, acidity, carbohydrates, and other substances we are sensitive to, fire off neural impulses that reach the parts of our brain that can make sense of them. Once believed to be limited to just sweet, sour, salty, and bitter sensations, we now know that we have many more, such as umami (a marker for protein), fat, carbonation, some forms of calcium like the flavor-enhancing kokumi, and metals such as iron and copper, and science will probably discover others. There is evidence to suggest that we are equipped to recognize all ten of the amino acids essential for life, but how we sense and interpret this is still a mystery. Sweet and fat tastes indicate high nutritional content, and our desire for them is innate. Bitterness is a warning from our friends in the plant world that whatever we’re tasting might be poison, and for that reason we are averse to it as well as highly sensitive. Enjoyment of bitter tastes runs counter to millions of years of evolution, which is why it takes most people a while to acquire a taste for bitter beers.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("There is very little truth to the old tongue map that located different tastes on specific parts of the tongue. In reality, the front half is equally sensitive to all tastes. At the back of the tongue there are areas on both sides that are somewhat more sensitive to sour, and across the very back is a row of taste buds that are more sensitive to bitterness and possibly other complex flavors like umami.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("Probably the biggest mistake I see is a lack of objective tasting skills. Until that skill is developed, new brewers can’t embark on the path of improving their brewing, as they have not yet recognized the off-flavor")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("HAROLD GULBRANSEN,")]), _vm._v(" award-winning brewer and QUAFF Homebrew Club organizer")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("Because of the way the chemical triggers are processed into nerve impulses, different tastes have different time constants. Sour and salty, for example, fire very rapidly to the brain, and register instantly. Because sweet, bitter, and umami are processed through intermediate proteins, they take a little longer to hit us and a little longer to leave. The result is that a taste is not just a single instant but a little movie that plays as different flavors come and go. One sip may last a minute or more.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Our sense of smell, known as olfaction, is much more complex than our sense of taste. A thousand different receptor types create about ten thousand different aromas by generating patterns of responses that are interpreted by the olfactory cortex, turned into “odor objects,” and sent elsewhere in the the brain, including inner, ancient structures like the hippocampus and amygdala. These are the seats of emotion and memory, among other things, responsible for those vivid flashbacks that sometimes accompany a smell and send us back to a moment in our childhood. Research has shown that even aromas we are unaware of can affect our emotional state.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("To further complicate things, we actually have two noses located in slightly different places. The first, the orthonasal, is right where you’d expect it to be, at the top of our nasal cavity. This is the sniffer we use to identify and evaluate and is somewhat more analytical than the other. The second center, the retronasal, is located just a bit farther back in our heads, and it responds to smells traveling up from the back of our mouths and throats. It is wired to parts of our brains that resonate with feelings of familiarity, preference, and dislike—it is the broccoli-hating, chocolate-loving part of your nose. Getting some aromas into both centers is important for a thorough evaluation of a beer’s aroma. This is why in critical tasting, various techniques are used for letting the liquid warm in the mouth and release aromas that exit through the nose. It’s also why swallowing beer, rather than spitting, is the norm during critical tasting or judging.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_c('em', [_vm._v("Flavor")]), _vm._v(" is a rather indefinite term. It is used casually to describe those sensations that come from aromas but present themselves in the mouth rather than the tongue. Science is coming around to the view that some of this is likely due to the way the retronasal center is wired; those “aromas” often come off more as flavors.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Mouthfeel is another important facet of beer. Nerves in our mouths respond to wetness, the prickle of carbonation, body, creaminess, astringency, and other stimuli. These characteristics add a lot to beer, and in certain styles they are very important. Some, like astringency, are not very pleasant and are definitely flaws in beer whenever they’re encountered.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("I always stress the significance of aroma. I have heard it argued that between 70 and 90 percent of total flavor perception is aroma. We always use the word")]), _vm._v(" taste. "), _c('em', [_vm._v("“This tastes like a strawberry.” There are more than 360 contributing aromas in a strawberry, but only 5 (or 6) tastes. Nope. It’s all in the nose, so you really gotta make the most of it. Swirl your glass; get those volatiles volatizing! Waft, short sniffs, longer sniff, and retronasal. But remember, this is it! Don’t do it again. Don’t fatigue, trust your first instincts—they are always right")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("LAUREN SALAZAR,")]), _vm._v(" beer blending and sensory specialist, New Belgium Brewing Co.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2lev6"
    }
  }), _vm._v("THE TASTING ACT")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("There are a number of different types of situations where beer is critically tasted, from informal evaluations to competition judging to rigorous professional taste panel work. While the specifics may differ, the actual process of tasting is much the same for all situations, and once you learn how to do it, you’ll find yourself approaching your first sip of every beer this way, no matter how bawdy the beerhall. I even find myself habitually sniffing my water glass these days.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("To give every beer its best shot, try to keep distractions to a minimum, be sure the beer is in good condition, at an appropriate temperature, and served at the right fill level in an appropriate glass. White wine glasses with a slightly incurved rim are best for critical tasting. Never fill more than about a third of the way full.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("First, smell. Many aroma compounds are extremely volatile and may vanish after a minute or two. Take small, short sniffs, not deep inhalations. When you overdo it, you saturate the receptors and they stop firing signals to the brain. If that happens, to reset take a short break or sniff something else, like the back of your hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Once you have an initial sense of the aroma, have a good look for color, clarity, and the staying power of the head. Then, take a sip. What are the tastes on your tongue? Any sweetness or acidity will register first. Pay attention to the bitterness as it builds and recedes. Let the liquid linger in your mouth. As it warms up, it will release more aroma. Breathe very gently in and out with your mouth partly closed, trying to get some of those aromas to go up and out through your nose. Finally, swallow, and breathe out slowly through your nose. At the very end, focus on the aftertaste. It should be clean and pleasant, in tune with the rest of the beer. If there are astringent or cardboardy, oxidized flavors, this is where you will find them.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Take notes on the experience. Writing things down helps you focus; and then you have a record of the experience. Pay special attention to those little aroma-triggered memory flashbacks. Bizarre as they seem, they can often put you in a place where you can name a very specific beer flavor chemical you encountered years ago in quite different circumstances. Unexpected memories of banana Runts, theater popcorn, or nail polish can point the way to quite specific beer aromas.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("You have several goals. Number-one is to discover what’s in the glass. Malt, hops, fermentation flavors, sweetness, bitterness, minerality, acidity—what do you get? Dig a little deeper. What’s the malt base? What malt types are adding the color, the caramel, the toastiness, the creamy texture? Same goes for the hops. Can you identify the nation of origin? Some hop varieties are pretty distinctive and can be called out by name if you’ve had some practice.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("How is the beer put together? Think about what recipe you might use to make this beer.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("ISO (INTERNATIONAL ORGANIZATION FOR STANDARDIZATION) STANDARD TASTING GLASS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "46 mm ± 5 130 mm ± 5 65 mm ± 5 65 mm ± 5 50ml 65 mm ± 5",
      "src": "images/f0038-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("Although this glass is the gold standard for critical tasting, any similarly shaped vessel will do nicely. Note that the proper level for tasting is about one-third full.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("Another important goal is to nitpick for flaws. A list of sensory defects is provided on the Atlas of Beer Flavor and Character on "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#page_40"
    }
  }, [_vm._v("page 40")]), _vm._v(". A critical evaluation will reveal that many beers have some small defect that affects flavor or aroma. If it’s your beer, you sure want to know about it.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Another task, especially in competitions, is evaluating whether the beer fits a designated style. This is central to judging in the Beer Judge Certification Program (BJCP) and World Beer Cup/Great American Beer Festival (GABF) competitions, where every beer is compared to a published standard. Sometimes a small deviation—ester aromas in a lager, for example—will be enough to knock a beer from contention, no matter how good it tastes otherwise. To make this sort of evaluation, you really need a good working knowledge of the guidelines, plus a sort of internal calibration of color, bitterness, gravity, aroma, and the other parameters that define a style.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("If you have the chance, it is really helpful to travel to the classic beer- producing regions to get on intimate terms with the different beer traditions. Beer that has crossed an ocean is often stale, changing a whole suite of subtle characteristics. The brands that are exported are not always the most representative examples of their home traditions and, for sure, a long voyage changes them noticeably. All beer tastes best and most characteristic when close to home.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Finally, step back and think about the intangibles. Is the beer balanced, lively, full of interesting tastes, textures, and aromas? Do they all work together, and if so, how? Are there two, three, or more different tastes that share the spotlight? Do they play nicely together? Does the beer feel like one thing all the way from the first whiff to that last lingering aftertaste? Sometimes, it does not. Would you drink a pint of this? Two? Would you pay for it? Lust after it? Will you be talking about this beer a year from now?")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0039-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Aftermath of a commercial competition in Rimini, Italy in 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hdnote"
  }, [_vm._v("Beer-Tasting Checklist")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "text_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("SMELL")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Take short sniffs, and try to capture those first impressions. Pinpoint aromas as specifically as you can. Use those memory flashbacks!")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("LOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Examine color, clarity, head retention.")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("TASTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Observe first flavors of sweetness, acidity, and pay attention as these drop away and bitterness builds. Are there any other flavors?")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("RETRONASAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("As you swallow, breathe out slowly through your nose. This is your second shot at capturing the beer’s aroma. The impressions may seem like flavor rather than aroma here.")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("MOUTHFEEL")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Note dryness, creaminess, body, etc. What about carbonation?")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("AFTERTASTE/FINISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("What do you sense after swallowing? Is the finish clean, astringent, quick, long, yummy?")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("STYLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Is the beer what it purports to be? How does it stack up against other beers of its ilk?")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/check.jpg"
    }
  }), _vm._v(" "), _c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("INTANGIBLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Do you like it? Do all the parts work together to create a coherent idea? Does it have any magic?")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2lev7"
    }
  }), _vm._v("AN ATLAS OF BEER FLAVOR AND CHARACTER")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hd"
  }, [_vm._v("BREWING")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_vm._v("PROCESS")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Recipe")])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Water Chemistry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Minerality")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Harshness")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Brewhouse")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Mash")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Boiling")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Fermentation")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sanitation")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Yeast Selection")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Yeast Health")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Temperature")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Conditioning")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Handling")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Freshness")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Oxidation/Stale Flavors")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lightstruck")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Carbonation")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Malt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Base")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Color/Flavor")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Adjuncts")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Grains")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Hops")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bittering")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Aroma")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Water")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Yeast")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Spices")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Fruit/Vegetables")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hd"
  }, [_vm._v("INTANGIBLE")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_vm._v("AESTHETIC")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Balance/Contrast")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Hop vs. Sweet Malt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Roast Components")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Acidity")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Two-Way, Three-Way . . .")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Drinkability")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Fatiguing")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Depth/Complexity")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Subtlety")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Coherence")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Memorability")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Originality")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Deliciousness!")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("STYLISTIC")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Gravity/Alcohol")])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Flavor Intensity")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Drinkability")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Color")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Malt Character")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Hop Aroma Intensity")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Hop Character")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Dry/Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Body")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Natural Character")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Fermentation Character")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Yeast Strain")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Fermentation Temperature")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hd"
  }, [_c('a', {
    attrs: {
      "id": "pg40lev3"
    }
  }), _vm._v("SENSORY")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_vm._v("VISUAL")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Beer Color")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Light/Dark")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Hue (red/yellow)")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Clarify/Haze")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Head")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Color")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Density/Creaminess")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Longevity")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("TONGUE TASTES")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Sweet")])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Sour")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Bitter")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Carbonation")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Salty/Mineral")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Metallic")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Umami (aged beer)")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("AROMA")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Pleasant/Unpleasant")])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Intensity")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Complexity")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Appropriateness")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("MOUTHFEEL")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Carbonation")])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Body")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Creamy")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Oily")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Astringent/Harsh")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Tannic")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Heat (chile)")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Hot (alcoholic)")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Beer is evaluated on a wide range of brewing, sensory, and aesthetic components. After some practice, a trained beer taster should be able to disassemble a beer into its component parts based on how the beer presents itself in the glass. This is a skill that may take years to master but is key to being able to brew world-class beers. This chart breaks the task into brewing, sensory, and intangible areas, all things a good taster should be thinking about when critically tasting a beer. The terms on these two pages will be discussed in detail in the next few chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The right-hand side expands the aroma vocabulary of the wide range of beers brewed today. While some are negative in every situation, be aware that many of these are highly dependent on context and beer style—what is appropriate in one style may be completely out of character in another style.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0040-01.jpg"
    }
  })])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "pg41lev1"
    }
  }), _vm._v("AROMA VOCABULARY")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-01.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("FERMENTATION"), _c('br'), _vm._v("—POSITIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Yeasty")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Alcohol/Ethanol")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Fruity/Estery")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Apply/Ethyl Hexanoate")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Apricots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Banana/Isoamyl Acetate")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bubblegum")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Melon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Peach")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pear")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Strawberry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pineapple")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Phenolic")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Black Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Clove/4-Vinyl Guaiacol")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Gumdrops/Allspice")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Sulfur")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Burnt Match/Sulfite")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Rotten Eggs/Sulfide")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Woody")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Aged")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Leathery (aged beer)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sherry")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Buttery (tiny amounts only)")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-02.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("FERMENTATION"), _c('br'), _vm._v("—NEGATIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Yeasty")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Acetaldehyde")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Acidic")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sour/Tangy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Acetic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lactic")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Chemical")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Acetone")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Alcohol/Ethanol")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Rubbing Alcohol/Fuses")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Fruity")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Estery (problem in lagers)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Apple/Ethyl Hexanoate")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Banana/Isoamyl Acetate")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bubblegum")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Overripe Pineapple")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Sulfur")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Burnt Match/Sulfite/Sulfure Dioxide")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Cooked Cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Cooked Corn/Dimethyl Sulfide (DMS)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Rotten Eggs/Hydrogen Sulfide")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Animal")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Buttery/Diacetyl")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Goaty/Caprylic, Caproic, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Barnyard/Horse Blanket")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Phenolic")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Band-Aid/Chlorephenol")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Medicinal")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Plastic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bakelite")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Aged")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Soapy/Autolyzed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Soy Sauce/Umami")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sherry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Beeswax")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-03.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("MALTS AND ADJUNCTS"), _c('br'), _vm._v("—POSITIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Grainy")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Corn Grits")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Cracker")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Malt")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Biscuit")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Honey")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Cookie")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Caramel")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Nuts")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Toffee")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Figs")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Raisins")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Prunes")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Spicy (Rye)")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Rum")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Toasted Marshmallow")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Burnt Sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Roast")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Chocolate")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Espresso")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-04.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("MALTS AND GRAINS"), _c('br'), _vm._v("—NEGATIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Worty")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Cooked Corn/DMS")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Cidery")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Extracty/Ball-Point Pen")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Grassy")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Astringent")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Oxidized")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Papery/Cardboard")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Husky/Phenolic/Smoky")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Ashtray/Campfire")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Bitter")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Burnt")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-05.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("SPICED BEERS"), _c('br'), _vm._v("—POSITIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Coriander")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Grains of Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Star Anise")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Licorice")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Allspice")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Lemongrass")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Chile")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Pumpkin Pie")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-06.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("SPICED BEERS"), _c('br'), _vm._v("—NEGATIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Hot-Dog Water")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Vegetal")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Overpowering")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-07.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("HOPS"), _c('br'), _vm._v("—POSITIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Grass")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Spicy"), _c('a', {
    attrs: {
      "id": "rpg41fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg41fn1"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Herbal")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sage")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Thyme")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Mint")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dill")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Fruity")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Apricot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Passionfruit")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Vinous/Sauvignon")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Citrus")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Grapefruit")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lemon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lime")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Orange")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Floral")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Rose")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Geranium")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lavender")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Resin")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sagebrush")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "id": "pg41fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#rpg41fn1"
    }
  }, [_vm._v("*")]), _vm._v("A rather indefinite term usually applied to hops, especially varieties like Saaz and Styrian Goldings types that are not easy to describe in other terms.")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-08.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("HOPS"), _c('br'), _vm._v("—NEGATIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Catty (blackcurrant/"), _c('em', [_vm._v("Ribes")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Onion/Garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Astringent")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Cheesy/Isovaleric Acid")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Lightstruck")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Burnt Rubber")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Skunky")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-09.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("WILD AND WOOD-AGED"), _c('br'), _vm._v("—POSITIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Acid/Sour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Vinegar/Acetic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lactic")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Alcohol/Ethanol")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Fruity/Estery")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Apple/Ethyl Hexanoate")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Apricots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Banana/Isoamyl Acetate")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pineapple")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Melon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Peach")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pear")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Strawberry")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Phenolic")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Black Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Clove/4-Vinyl Guaiacol")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Earthy")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Barnyard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Horse Blanket")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Tobacco")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Yeasty")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Vinous")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Woody")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Oaky")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Coconut")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Tannic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Rosewood")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "88%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/f0041-10.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('strong', [_vm._v("WILD AND WOOD-AGED"), _c('br'), _vm._v("—NEGATIVE")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent1"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Acid/Sour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Vinegar/Acetic")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Estery/Ethyl Acetate")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Earthy")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Musty/Trichloroanisole")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2lev8"
    }
  }), _vm._v("JUDGING, COMPETITIONS, "), _c('span', {
    staticClass: "font"
  }, [_vm._v("and")]), _vm._v(" CERTIFICATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Learning to be a great taster is something that you can do on your own, but it is far more productive in the company of others, especially those with more experience. The best way to put yourself in this position is to become a judge and stay active in homebrew competitions. You will taste a huge range of beers, often in the company of some very skilled judges, which is an incredible learning experience. In fact, even after evaluating beer seriously for more than twenty-five years, every time I sit down at a judging table, I learn something new.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The Beer Judge Certification Program (BJCP) is an all-volunteer nonprofit organization that certifies judges and sanctions competitions around the world. In order to become certified, you are required to take a test that covers a range of brewing and stylistic knowledge, as well as your ability to taste beers, rate them according to a style category, and identify some faults. A certain score gets you into the basic “recognized” judge category; higher scores and more experience points allow you to rise to higher levels of certification.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Competition organizers are always looking for people to help, so the best way to get started is to volunteer as a steward at your local competition. This job involves presenting judges with the proper beers in the right condition, and because you’re hovering around the judging tables, it’s a good way to get a feel for how the process goes. Some homebrew clubs regularly do practice judging; it’s easy to accommodate a request for this, so don’t feel shy about showing up at the club meeting and asking.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("While there is no official preparatory course, many people preparing for the BJCP exam will form study groups and meet every week or two to taste and discuss the specifics of the twenty-eight styles of beer, mead, and cider that form the BJCP category list. You can download the BJCP guidelines in various forms along with other study material at "), _c('a', {
    attrs: {
      "href": "http://www.bjcp.org",
      "target": "_blank"
    }
  }, [_vm._v("www.bjcp.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Improving your ability as a beer taster is different from most learning we do. Tasting involves some very ancient and often hidden parts of our brains, and training them isn’t as straightforward as memorizing some facts and figures. But if you do put the effort into it, your brain will respond and you will emerge a much more sensitive, capable, and maybe even self-aware person. Who knew beer could do "), _c('em', [_vm._v("that")]), _vm._v("?")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0042-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Edward Bronson")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("My training to become a beer judge was the most important factor for improvement of my brewing")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("JOE FORMANEK,")]), _vm._v(" flavor chemist and winner of 2000 and 2006 Ninkasi Awards")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0043-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("row by row from top left: Homebrew labels by Kim Theeson, Robert Alvord, Jim LaFleur, Steve Mastny, Grzegorz Zagłoba/Bartosz Wojtyra, Bogumil Rychlak, Randy LaCoille, Matteo Pellis/Alberto Bodritti, Szymon Tracz, Łukasz Szynkiewicz, Kim Theesen, Juleidy Peña, Tara Leigh Z, Marcin Lipiński, and Steve Mastny.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-127643a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09-chapter02.vue
// module id = 81
// module chunks = 0